import { z } from 'zod';
import type { TFunction } from 'i18next';

export const createClientSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t('clients:errors.nameRequired')),
    taxId: z
      .string()
      .min(1, t('clients:errors.taxIdRequired'))
      .max(13, t('clients:errors.taxIdMax', { max: 13 })),
  });

export type ClientFormValues = z.infer<ReturnType<typeof createClientSchema>>;
